<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <persons-form :person="person" :disabled="disabled" @activate-mod="activateMod()"
                              @click="updatePerson()"
                              :showLabels="true"></persons-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import personsApi from '../../api/persons'
  import personsForm from './Form.vue'

  export default {

    components: {
      personsForm
    },

    data () {
      return {
        person: false,
        disabled: true,
        interval: null
      }
    },

    beforeCreate () {
      personsApi.show(this.$route.params.id)
        .then((response) => {
          this.person = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Persone inserite',
        createButton: {
          display: true,
          text: 'Nuova persona',
          to: '/person'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          personsApi.update(this.$route.params.id, this.person)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updatePerson () {
        this.loader = true
        return personsApi.update(this.$route.params.id, this.person)
          .then((response) => {
            toastr.success('La persona è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/persons/Show.vue